import { useFeedStore } from '@modules/feed/store/feedStore';
import { FeedActionType } from '@modules/feed/store/searchActionType';
import { getFeedQueryRetentionKey } from '@modules/feed/utils';
import { parseStringifiedDuration } from '@modules/feed/utils/parseStringifiedDuration';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';

export const useFeedSessionStorage = () => {
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const dispatch = useFeedStore(({ dispatch }) => dispatch);
  const query = useFeedStore(({ query }) => query);
  const prompt = useFeedStore(({ prompt }) => prompt);

  const setSessionStorageFromFeedStore = useCallback(() => {
    sessionStorage.setItem(
      getFeedQueryRetentionKey(tenantSlug),
      JSON.stringify({
        query,
        prompt,
      }),
    );
  }, [prompt, query, tenantSlug]);

  const setFeedStoreFromSessionStorage = useCallback(() => {
    const persistedState = sessionStorage.getItem(
      getFeedQueryRetentionKey(tenantSlug),
    );

    if (persistedState) {
      try {
        const persistedQueryAndPrompt = JSON.parse(persistedState);

        dispatch({
          type: FeedActionType.SET_UPDATE_QUERY,
          payload: {
            ...persistedQueryAndPrompt.query,
            duration: parseStringifiedDuration(
              persistedQueryAndPrompt.query.duration,
            ),
          },
        });

        dispatch({
          type: FeedActionType.SET_PROMPT,
          payload: persistedQueryAndPrompt.prompt,
        });
      } catch {
        sessionStorage.removeItem(getFeedQueryRetentionKey(tenantSlug));
      }
    }
  }, [dispatch, tenantSlug]);

  return {
    setSessionStorageFromFeedStore,
    setFeedStoreFromSessionStorage,
  };
};
